export default {
    state: {
        selectedFacCategory: '',
        selectedFacSqnos: [],
    },
    getters: {
        getSelectedFacCategory(state) {
            return state.selectedFacCategory;
        },
        getSelectedFacSqnos(state) {
            return state.selectedFacSqnos;
        },
    },
    mutations: {
        SELECTED_FAC_CATEGORY(state, selectedFacCategory) {
            state.selectedFacCategory = selectedFacCategory;
        },
        SELECTED_FAC_SQNOS(state, selectedFacSqnos) {
            state.selectedFacSqnos = selectedFacSqnos;
        },
    },
    actions: {
        SET_SELECTED_FAC_CATEGORY({commit}, selectedFacCategory) {
            commit('SELECTED_FAC_CATEGORY', selectedFacCategory);
        },
        SET_SELECTED_FAC_SQNOS({commit}, selectedFacSqnos) {
            commit('SELECTED_FAC_SQNOS', selectedFacSqnos);
        },
    }
}
